<template>
  <v-menu
    v-model="menu"
    :disabled="disabled"
    :close-on-content-click="false"
    :close-on-click="false"
    top
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        :loading="readFilesLoading"
        :disabled="disabled || disabledUpload"
        class="ma-0"
        v-on="on"
        @click="confirm ? (showActionDialog = true) : showFileDialog()"
      >
        <v-icon>publish</v-icon>
      </v-btn>
    </template>
    <v-card v-if="!confirm">
      <v-card-title class="pb-2">
        <h2 class="title font-weight-bold">
          Загрузка файлов
        </h2>
      </v-card-title>
      <v-card-text
        :class="['py-0', `${files.length > 6 ? 'document-list' : ''}`]"
      >
        <v-layout column>
          <v-layout
            v-for="file in files"
            :key="file.sourceName"
          >
            <v-flex
              xs6
              class="px-1"
            >
              <v-text-field
                v-model="file.originName"
                label="Имя вложения"
                hide-details
                @change="changeOriginName"
              />
            </v-flex>
            <v-flex
              xs6
              class="px-1"
            >
              <v-text-field
                disabled
                hide-details
                label="Имя файла"
                :value="file.sourceName"
              />
            </v-flex>
          </v-layout>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          flat
          color="primary"
          :loading="uploadFilesLoading"
          :disabled="!files.length"
          @click="upload"
        >
          Ок
        </v-btn>
        <v-btn
          flat
          @click="close"
        >
          Отмена
        </v-btn>
      </v-card-actions>
    </v-card>
    <app-action-confirm
      v-else
      :value="showActionDialog"
      :text="needConfirmText"
      @cancel="showActionDialog = false"
      @confirm="showFileDialog()"
    />
  </v-menu>
</template>
<script>
import upload from "./upload.js";
import * as attachmentsApi from "../../backend/attachmentsApi.js";

export default {
  props: [
    "disabled",
    "resource",
    "disabledSender",
    "disabledUpload",
    "disabledUploadToServer",
    "type",
    "needConfirm",
    "needConfirmText",
  ],
  data() {
    return {
      menu: false,
      files: [],
      readFilesLoading: false,
      uploadFilesLoading: false,
      confirm: false,
      showActionDialog: false,
    };
  },
  watch: {
    needConfirm: {
      handler(val) {
        this.confirm = val;
      },
      immediate: true,
    },
  },
  methods: {
    showFileDialog() {
      this.showActionDialog = false;
      this.confirm = false;
      upload().then(files => {
        this.files = this.files.concat(files);
        if (this.type) {
          this.files.forEach(f => (f.type = this.type));
        }
        this.menu = true;
      });
    },
    async upload() {
      if (this.disabledUploadToServer) {
        this.$emit("upload", this.files);
        this.menu = false;
        this.files = [];
      } else {
        this.uploadFilesLoading = true;
        const res = await attachmentsApi.uploadAttachment(
          this.resource,
          this.files,
        );
        this.uploadFilesLoading = false;
        this.menu = false;
        this.files = [];
        this.showInfo("Файл добавлен");
        this.$emit("upload", res);
      }
      this.confirm = this.needConfirm;
    },
    close() {
      this.menu = false;
      this.files = [];
      this.confirm = this.needConfirm;
    },
    changeOriginName(newValue) {
      this.files.forEach(file => {
        if (
          file.originName === newValue &&
          file.originName != file.sourceName
        ) {
          const splitSourceName = file.sourceName.split(".");
          const extention = splitSourceName[splitSourceName.length - 1];
          file.originName = newValue.includes(extention)
            ? newValue
            : `${newValue}.${extention}`;
        }
      });
    },
  },
};
</script>
<style>
.document-list {
  height: 290px;
  overflow-y: auto;
}
</style>
